import React from "react";

const SectionThree = (props) => {
  const { openMod } = props;
  return (
    <section>
      <div className="container">
        <div className="row justify-content-center">
          <div className="text-center inte">
            <p className="bigPh">Apps you can currently Integrate with</p>
            <img alt="plugit" className="plugi" src="plugit.gif" />
            <h6 className="tabtext">
              Ready to Automate your store? Try PlugIt for free!
              <br /> Book a demo with the team and let’s get those tasks off
              your plate!
            </h6>
            <button onClick={openMod} className="butn butn-primary ">
               Book a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionThree;
